<template>
  <button
    type="button"
    :aria-label="`${count} ${noun}, review`"
    class="relative flex h-[35px] cursor-pointer items-center gap-x-3 rounded-full bg-[#fbfbfb]/70 px-2.5 backdrop-blur-xl transition-transform duration-100 active:scale-[0.96]"
    @click="emit('review')"
  >
    <span aria-hidden="true" class="shadow--glass-pill"><i></i></span>
    <span class="flex items-center gap-x-2">
      <AlertCircleIcon class="size-[19px] text-red-500" aria-hidden="true" />
      <span
        class="flex overflow-hidden text-[14px] leading-[22px] font-medium text-red-500"
      >
        <Transition
          mode="out-in"
          enter-active-class="transition duration-200 ease-out"
          enter-from-class="translate-y-2 opacity-0"
          leave-active-class="transition duration-150 ease-in"
          leave-to-class="-translate-y-2 opacity-0"
        >
          <span :key="count">{{ count }}</span>
        </Transition>
        <span>&nbsp;{{ noun }}</span>
      </span>
    </span>
    <span class="h-[25px] w-px bg-gray-900/10" aria-hidden="true" />
    <span
      class="flex items-center gap-x-[2px] text-[14px] leading-[22px] font-medium text-gray-800"
    >
      Review
      <ChevronRightIcon class="size-3" aria-hidden="true" />
    </span>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { AlertCircleIcon, ChevronRightIcon } from '@dacr/icons'

const props = defineProps<{ count: number }>()

const emit = defineEmits<{ review: [] }>()

const noun = computed(() => (props.count === 1 ? 'match' : 'matches'))
</script>
